module.exports = __webpack_public_path__ + "whitescentsticks.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitescentsticks.png
// module id = 903
// module chunks = 0